export default __webpack_public_path__ + "static/media/pic83.794b66a0.jpg";